"use client";

import { IlluAnalyse } from "@/app/(components)/generics/Illustrations/IlluAnalyse/IlluAnalyse";
import { IlluCalendar } from "@/app/(components)/generics/Illustrations/IlluCalendar/IlluCalendar";
import { IlluHandshake } from "@/app/(components)/generics/Illustrations/IlluHandshake/IlluHandshake";
import { IlluProject } from "@/app/(components)/generics/Illustrations/IlluProject/IlluProject";
import { IlluWhy } from "@/app/(components)/generics/Illustrations/IlluWhy/IlluWhy";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { JourneyItemKeys } from "@/app/types/home/HomeJourney";
import homeStyles from "../../Home.module.css";
import styles from "./TheJourney.module.css";

type Props = DefaultProps & {
  keys: JourneyItemKeys[];
};

export default function TheJourney(props: Props) {
  const T = useT();

  const icons = [
    <IlluAnalyse key="1" />,
    <IlluWhy key="2" />,
    <IlluHandshake key="3" />,
    <IlluCalendar key="4" />,
    <IlluProject key="5" />,
  ];

  const items = props.keys.map((k, index) => ({
    phase: `0${index + 1}`,
    icon: icons[index % icons.length],
    title: T(k.title),
    text: T(k.text),
  }));

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.timeline}>
          {items.map((item, index) => (
            <div key={`home-journey-item-${index}`} className={styles.journeyItem}>
              <div className={styles.phaseCard}>
                <div className={styles.phaseHeader}>
                  <span className={styles.phaseLabel}>{item.phase}</span>
                  <div className={styles.iconWrapper}>{item.icon}</div>
                </div>

                <div className={styles.itemTexts}>
                  <h3 className={styles.itemTitle}>{item.title}</h3>
                  <p className={homeStyles.text}>{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
